module.exports = __webpack_public_path__ + "img/gallery-1.618a96be.jpg";